import { API_REQUEST } from ".";
import {
  blockUnblockedUserAPI,
  deleteUsersAPI,
  filterUserAPI,
  usersAPI,
  getVarificationDataAPI,
  dashboardAPI,
  verifyUserAPI,
  RejectUserEndPointURL,
} from "../../routes/apiEndPoints";
import { createAsyncThunk } from "@reduxjs/toolkit";

// fetch-users
export const fetchUsers = createAsyncThunk("fetch-users", async () => {
  try {
    const response = await API_REQUEST({
      url: usersAPI,
      method: "GET",
    });
    return response;
  } catch (error) { }
});

// delete-user
export const deleteUser = createAsyncThunk("delete-user", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: deleteUsersAPI,
      method: "DELETE",
      data: payload,
    });
    callback(response);
    return response;
  } catch (error) { }
});

//  blocked Unblocked user
export const blockUnblockedUser = createAsyncThunk(
  "Blocked-Unblocked-user",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: blockUnblockedUserAPI,
        method: "POST",
        data: payload,
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);


//filter-user
export const filterUser = createAsyncThunk("filter-user", async (props) => {
  const { payload } = props
  const { country, city, gender, search, status } = payload;
  const params = {};
  if (country) params.country = country;
  if (city) params.city = city;
  if (gender) params.gender = gender;
  if (search) params.search = search;
  if (status) params.status = status;
  try {
    const response = await API_REQUEST({
      url: filterUserAPI,
      method: "GET",
      params: params,
    });
    return response;
  } catch (error) { }
});


// get-verification-data
export const getVarificationData = createAsyncThunk("get-verification-data", async () => {
  try {
    const response = await API_REQUEST({
      url: getVarificationDataAPI,
      method: "GET",
    });
    return response;
  } catch (error) { }
});

// verify-user
export const verifiedUser = createAsyncThunk("verify-user",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: verifyUserAPI,
        method: "POST",
        data: payload,
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

export const rejectUser = createAsyncThunk("reject-user",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: RejectUserEndPointURL,
        method: "POST",
        data: payload,
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

// get-dashboard-data
export const getdashboard = createAsyncThunk("get-dashboard-data", async () => {
  try {
    const response = await API_REQUEST({
      url: dashboardAPI,
      method: "GET",
    });
    return response;
  } catch (error) { }
});